module.exports = __webpack_public_path__ + "media/images/web/favicon/ms-icon-310x310-0a50e29967a71b497300ce3bc1a57aad.png";